import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProviderQuoteModule } from '@approot/provider-quote/provider-quote.module';
import { PrettyDatePipe } from '@approot/shared/pipes/pretty-date/pretty-date.pipe';
import { AgCharts } from 'ag-charts-angular';
import { AgGridModule } from 'ag-grid-angular';
import { SharedModule } from '../shared/shared.module';
import { BlotterComponent } from './blotter/blotter.component';
import { CashFlowsBlotterComponent } from './cash-flows-blotter/cash-flows-blotter.component';
import { DeltaHedgesComponent } from './delta-hedges/delta-hedges.component';
import { EventsBlotterComponent } from './events-blotter/events-blotter.component';
import { LifecycleBlotterComponent } from './lifecycle-blotter/lifecycle-blotter.component';
import { PNLBlotterComponent } from './pnl-blotter/pnl-blotter.component';
import { PnlPivotTableComponent } from './pnl-blotter/pnl-pivot-table/pnl-pivot-table.component';
import { PositionsDetailComponent } from './positions-detail.component';
import { RisksBlotterComponent } from './risks-blotter/risks-blotter.component';
import { HistoricalTradesComponent } from './trades-grid/historical-trades/historical-trades.component';
import { AllocateTradeComponent } from './trades-grid/trade-manager/allocate-trade/allocate-trade.component';
import { ArchiveTradesComponent } from './trades-grid/trade-manager/archive-trades/archive-trades.component';
import { LoadTradeVersionsComponent } from './trades-grid/trade-manager/load-trade-versions/load-trade-versions.component';
import { TradeManagerComponent } from './trades-grid/trade-manager/trade-manager.component';
import { TradesGridComponent } from './trades-grid/trades-grid.component';
import { BackToBackChartComponent } from './white-label-blotter/back-to-back-trades/back-to-back-trades-chart/back-to-back-trades-chart.component';
import { BackToBackComponent } from './white-label-blotter/back-to-back-trades/back-to-back-trades.component';
import { DealDetailsGraphComponent } from './white-label-blotter/deal-details-graph/deal-details-graph.component';
import { RequestIdCellRendererComponent } from './white-label-blotter/request-id-cell-renderer/request-id-cell-renderer.component';
import { WhiteLabelBlotterComponent } from './white-label-blotter/white-label-blotter.component';

@NgModule({
  declarations: [
    PositionsDetailComponent,
    TradesGridComponent,
    BlotterComponent,
    HistoricalTradesComponent,
    TradeManagerComponent,
    ArchiveTradesComponent,
    LoadTradeVersionsComponent,
    AllocateTradeComponent,
    WhiteLabelBlotterComponent,
    EventsBlotterComponent,
    RisksBlotterComponent,
    PNLBlotterComponent,
    CashFlowsBlotterComponent,
    PnlPivotTableComponent,
    BackToBackComponent,
    BackToBackChartComponent,
    LifecycleBlotterComponent,
    RequestIdCellRendererComponent,
    DealDetailsGraphComponent,
    DeltaHedgesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AgGridModule,
    ProviderQuoteModule,
    AgCharts
  ],
  exports: [
    PositionsDetailComponent,
    TradesGridComponent,
    BlotterComponent,
    PnlPivotTableComponent,
    BackToBackComponent,
    BackToBackChartComponent,
    LifecycleBlotterComponent
  ],
  providers: [PrettyDatePipe]
})
export class PositionsDetailModule {}
